import {ApiSortsDerived} from '@/api/meta/odata';
import {getDetailContact} from '@/api/module/contact';
import Contact, {ApiContact, DetailContactFilters} from '@/model/Contact';
import {createVersionedStorage} from './types';

const useDetailContacts = createVersionedStorage<
  DetailContactFilters,
  ApiSortsDerived<ApiContact>,
  Contact|null
>('detailContact', {
  fetchFn: getDetailContact,
  defaultData: null,
  defaultFilters: {},
  defaultSorts: [],
});

export type ContactsStore = ReturnType<typeof useDetailContacts>
export default useDetailContacts;
